import React from "react";

import { RouteConfig } from "@/routes/routes";
import { PUSH } from "@/shared/constants/routes";

import PushRoutes from "@/features/push/presentation/routes/PushRoutes";

export const routes: RouteConfig[] = [
  {
    path: PUSH,
    element: <PushRoutes />,
    isPrivate: true
  }
];
